import { getRetentionScript, getWinbackScript } from "./verificationScripts"
import { useAccount } from "@apis/accounts/useAccounts"
import type { IAccount } from "@apis/accounts/types"
import type { IMarketCurrentPtc } from "@apis/pricing/types"
import { useAccountOfferFunnel } from "./useAccountOfferFunnel"
import { useGetMarketCurrentPtcQuery } from "@apis/pricing/usePricing"
import type { IWinbackOffer } from "@apis/winbacks/types"
import type { IRetentionOffer } from "@apis/retention/types"
import { serializeScript } from "@utils/verificationScriptsUtils"

export const useSerializeOfferScript = () => {
  const { account_id, offerType, selectedOffer } = useAccountOfferFunnel()

  const getAccountQuery = useAccount(account_id)
  const getCurrentPtcQuery = useGetMarketCurrentPtcQuery(
    getAccountQuery.data?.market_code,
    getAccountQuery.data?.revenue_class_code,
  )

  const script =
    offerType === "Winback"
      ? getWinbackScript(
          getAccountQuery.data as IAccount,
          selectedOffer as IWinbackOffer,
          getCurrentPtcQuery.data as IMarketCurrentPtc,
        )
      : getRetentionScript(
          getAccountQuery.data as IAccount,
          selectedOffer as IRetentionOffer,
        )

  return {
    script: serializeScript(script),
    account_number: getAccountQuery.data?.account_number,
    prospect_guid: getAccountQuery.data?.prospect_guid,
    market: getAccountQuery.data?.market,
  }
}
